import _ from 'lodash'
import createWob from '../create-wob'
import option from 'scoreboard/components/bootslide/menu-icon-option'
import i18n from 'scoreboard/components/i18n'
import ShapeModel from './shape-model'

import { DEFAULT_WIDGET_PROPERTIES } from './create-shape-widget-menu'

/**
 * Creates a menu option for adding a "line" shape widget to a dashboard.
 * Note that this creates a "shape" widget, just with properties that are
 * appropriate for a "line" shape.
 *
 * @param {Object} addWidgetMenu - the bootslide menu for adding widgets
 */
function createLineWidgetOption (addWidgetMenu) {
	let label = 'dashboards.shape.line'
	return {
		label: i18n.get(label),
		content: option('wob-line-solid', label),
		target: () => createLineWidget(addWidgetMenu)
	}
}

function createLineWidget (addWidgetMenu) {
	let wobAttributes = {
		width: 200,
		height: 2,
		outlineWidth: '2px',
		outlineColor: 'gray-darker'
	}

	let properties = _.extend({},
		DEFAULT_WIDGET_PROPERTIES,
		{
			shape: 'line',
			shapeHeight: wobAttributes.height
		})

	let widget = new ShapeModel(
		{ properties },
		{ section: addWidgetMenu.model.get('section') })

	createWob(addWidgetMenu.canvas, widget,
		{
			fetchData: false,
			wobAttributes
		},
		addWidgetMenu)
}

export default createLineWidgetOption

createLineWidgetOption.__filename__ = 'dashboards/widgets/shape/create-line-widget-option.js'
